import {
  SAVE_AUDIT_DATA,
  TEST_ACTION,
  UPDATE_ERROR_STATE,
} from "../actionTypeConstants/constants";

const initialState = {
  stage: false,
  error: false,
};

const performanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEST_ACTION:
      return { ...state, stage: true };
    case SAVE_AUDIT_DATA:
      const { auditData } = action.payload;
      const { mobile, desktop, local_report } = auditData;
      const {
        data: mobileData,
        analytic_response: mobileAnalyticData,
      } = mobile;
      const {
        data: desktopData,
        analytic_response: desktopAnalyticData,
      } = desktop;

      const performanceData = { ...local_report };
      const tempMobile = { ...mobileData.categories, ...mobileAnalyticData };
      const tempDesktopData = {
        ...desktopData.categories,
        ...desktopAnalyticData,
      };
      const audit = {
        mobile: { ...tempMobile },
        desktop: { ...tempDesktopData },
      };
      console.log({ audit });
      return { ...state, performanceData, audit, error: false };
    case UPDATE_ERROR_STATE:
      const { status } = action.payload;
      return { ...state, error: status };
    default:
      return state;
  }
};
export default performanceReducer;
